import { useDispatch } from 'react-redux'
import * as actions from '../../redux/actions/cart'
import { useMemo } from 'react'
import { bindActionCreators } from 'redux'

export function useSquareCheckout() {
  const dispatch = useDispatch()

  const getStates = useMemo(
    () => bindActionCreators(actions.getStates, dispatch),
    [dispatch]
  )

  const getUserWallet = useMemo(
    () => bindActionCreators(actions.getUserWallet, dispatch),
    [dispatch]
  )

  const updateOrderAddresses = useMemo(
    () => bindActionCreators(actions.updateOrderAddresses, dispatch),
    [dispatch]
  )

  const updateOrderDelivery = useMemo(
    () => bindActionCreators(actions.updateOrderDelivery, dispatch),
    [dispatch]
  )

  const updateOrderPayment = useMemo(
    () => bindActionCreators(actions.updateOrderPayment, dispatch),
    [dispatch]
  )

  const finalizeCheckout = useMemo(
    () => bindActionCreators(actions.finalizeSquareCheckout, dispatch),
    [dispatch]
  )

  return {
    getStates,
    getUserWallet,
    updateOrderAddresses,
    updateOrderDelivery,
    updateOrderPayment,
    finalizeCheckout,
  }
}
